<template>
  <div class="topbar">
    <div
      id="c-mask-user-menu"
      @click="toggleUserMenu()"
      v-bind:class="{ 'is-active': !isUserMenuHidden }"
    ></div>

    <nav class="nav">
      <div class="nav-left">

        <div class="nav-item">
          <div class="block-cont">
            <div class="level">
              <div class="level-item">
                <strong>
                  <!-- <router-link
                    v-if="isProductionContext"
                    :to="{name: 'main-schedule'}"
                  >
                    {{ $t("schedule.title_main") }}
                  </router-link> -->
                  <router-link
                    v-if="isProductionContext"
                    :to="{name: 'main-schedule'}"
                  >
                    {{ $t("schedule.title_main") }}
                  </router-link>
                  <router-link
                    v-else
                    :to="getContextRoute(currentProjectSection)"
                  >
                    Back To Production:
                  </router-link>
                </strong>
              </div>
            </div>
          </div>
          <div class="flexrow">
            <topbar-production-list
              class="flexrow-item context-selector"
              :episode-id="currentEpisodeId"
              :production-list="openProductions"
              :production="currentProduction"
              section="playlists"
            />
            <div class="flexrow-item" v-if="isEpisodeContext">
              <chevron-right-icon
                class="align-middle"
                size="20"
              />
            </div>
            <topbar-episode-list
              class="flexrow-item context-selector episode-selector"
              :episode-groups="currentEpisodeOptionGroups || []"
              :episode-id="this.currentEpisode.id"
              section="playlists"
              v-if="isEpisodeContext"
            />
            <div class="flexrow-item" v-if="currentProjectSection === 'playlists' && playlistOptions.length > 0">
              <chevron-right-icon
                class="align-middle"
                size="20"
              />
            </div>
            <combobox
              v-if="currentProjectSection === 'playlists' && playlistOptions.length > 0"
              class="context-selector flexrow-item"
              :options="playlistOptions"
              v-model="playlistSelected"
            />
          </div>
        </div>
      </div>

      <div class="nav-right">
        <div class="flexrow production-links">
          <strong>
            <router-link :to="getContextRoute('playlists')">
              {{ $t("playlists.title") }}
            </router-link>
          </strong>
          <strong>
            <router-link :to="getContextRoute('sequence-stats')">
              {{ $t("sequences.stats_title") }}
            </router-link>
          </strong>
          <strong>
            <router-link :to="getContextRoute('production-asset-types')">
              {{ $t("asset_types.production_title") }}
            </router-link>
          </strong>
          <strong v-if="isTVShow">
            <router-link :to="getContextRoute('episode-stats')">
              {{ $t("episodes.stats_title") }}
            </router-link>
          </strong>
        </div>
        <notification-bell />
        <div class="nav-item">
          <a
            class="changelog-button help-button"
            href="https://kitsu.cg-wire.com/"
            target="_blank"
          >
            <help-circle-icon />
          </a>
        </div>
        <div
          :class="{
            'nav-item': true,
            'user-nav': true,
            active: !isUserMenuHidden
          }"
          ref="user-name"
          @click="toggleUserMenu"
        >
          <people-avatar
            ref="avatar"
            class="avatar"
            :no-cache="true"
            :person="user"
            :is-link="false"
          />
          <people-name
            class="user-name"
            :person="user"
          />
        </div>
      </div>
    </nav>

    <nav
      class="user-menu"
      ref="user-menu"
      v-show="!isUserMenuHidden"
    >
      <ul>
        <li>
          <router-link to="/profile" @click.native="toggleUserMenu()">
            {{ $t("main.profile") }}
          </router-link>
        </li>
        <li @click="toggleDarkTheme">
          <span v-if="!isDarkTheme">
            {{ $t('main.dark_theme') }}
          </span>
          <span v-else>
            {{ $t('main.white_theme') }}
          </span>
        </li>
        <li>
          <a
            href="https://www.youtube.com/playlist?list=PLp_1gB5ZBHXqnQgZ4TCrAt7smxesaDo29"
            target="_blank"
          >
            {{ $t('main.tutorials') }}
          </a>
        </li>
        <li>
          <a
            @click="display.shortcutModal = true"
          >
            {{ $t('keyboard.shortcuts') }}
          </a>
        </li>
        <li @click="onLogoutClicked">
          {{ $t("main.logout") }}
        </li>
        <li class="version">
          Kitsu {{ kitsuVersion }}
        </li>
      </ul>
    </nav>

    <shortcut-modal
      :active="display.shortcutModal"
      @cancel="display.shortcutModal = false"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {
  ChevronRightIcon,
  HelpCircleIcon,
  LogOutIcon
} from 'vue-feather-icons'

import Combobox from '@/components/widgets/Combobox'
import GlobalSearchField from '@/components/tops/GlobalSearchField'
import NotificationBell from '@/components/widgets/NotificationBell'
import PeopleAvatar from '@/components/widgets/PeopleAvatar'
import PeopleName from '@/components/widgets/PeopleName'
import ShortcutModal from '@/components/modals/ShortcutModal'
import TopbarProductionList from '@/components/tops/TopbarProductionList'
import TopbarEpisodeList from '@/components/tops/TopbarEpisodeList'
import { getPlaylistPath } from '@/lib/path'
import { version } from '@/../package.json'

export default {
  name: 'client-topbar',
  components: {
    Combobox,
    GlobalSearchField,
    ChevronRightIcon,
    HelpCircleIcon,
    LogOutIcon,
    NotificationBell,
    PeopleName,
    PeopleAvatar,
    TopbarProductionList,
    TopbarEpisodeList,
    ShortcutModal
  },

  data() {
    return {
      currentProductionId: this.$route.params.production_id,
      currentEpisodeId: this.$route.params.episode_id,
      currentProjectSection: 'playlists',
      kitsuVersion: version,
      playlistOptions: [],
      playlistSelected: null,
      silent: false,
      display: {
        shortcutModal: false
      }
    }
  },

  mounted () {
    const userMenu = this.$refs['user-menu']
    const userName = this.$refs['user-name']
    if (userName) {
      const userNameWidth = userName.clientWidth

      if (userNameWidth > 100) {
        userMenu.style.width = `${userNameWidth}px`
        userName.style.width = `${userNameWidth}px`
      }
    }

    // this.setProductionFromRoute()
  },

  computed: {
    ...mapGetters([
      'assetsPath',
      'sequenceMap',
      'currentEpisode',
      'currentProduction',
      'episodes',
      'episodeOptionGroups',
      'isCurrentUserAdmin',
      'isCurrentUserArtist',
      'isCurrentUserManager',
      'isCurrentUserSupervisor',
      'isCurrentUserVendor',
      'isDarkTheme',
      'isSidebarHidden',
      'isSupportChat',
      'isUserMenuHidden',
      'isTVShow',
      'isNewNotification',
      'lastProductionScreen',
      'lastProductionViewed',
      'mainConfig',
      'openProductions',
      'openProductionOptions',
      'playlists',
      'productionMap',
      'productionEditTaskTypes',
      'user'
    ]),

    assetSections() {
      return ['assets', 'assetTypes', 'playlists']
    },

    editSections() {
      return ['edits']
    },

    shotSections() {
      return ['shots']
    },

    breakdownSections() {
      return ['breakdown']
    },

    // Asset pages require a all section and a main pack section.
    currentEpisodeOptionGroups() {
      if (this.assetSections.includes(this.currentProjectSection)) {
        return [
          {
            name: '',
            episodeList: [
              { label: this.$t('main.all_assets'), value: 'all' },
              { label: 'Main Pack', value: 'main' }
            ]
          }
        ].concat(this.episodeOptionGroups)
      } else if (['playlists'].includes(this.currentProjectSection)) {
        return [
          { label: this.$t('main.all_assets'), value: 'all' },
          { label: 'Main Pack', value: 'main' }
        ].concat(this.episodeOptions)
      } else {
        return this.episodeOptionGroups
      }
    },

    hasEpisodeId() {
      return this.$route.params.episode_id
    },

    isProductionContext() {
      return (
        this.$route.params.production_id !== undefined ||
        this.$route.path.indexOf('my-tasks') === 0
      )
    },

    isEpisodeContext() {
      return (
        this.currentEpisodeOptionGroups.length > 0 &&
        this.isTVShow &&
        this.currentProjectSection !== 'episode-stats'
      )
    },

    lastProduction() {
      let production = this.productionMap.get(this.lastProductionViewed)
      if (!production) {
        production = this.currentProduction
      }
      return production
    },

    lastSectionPath() {
      const production = this.lastProduction
      const section = this.lastProductionScreen
      const route = {
        name: section,
        params: {
          production_id: production.id
        }
      }
      if (production.production_type === 'tvshow') {
        route.name = `episode-${section}`
        route.params.episode_id = production.first_episode_id
      }
      return route
    },
  },

  methods: {
    ...mapActions([
      'clearEpisodes',
      'clearSelectedTasks',
      'loadEpisodes',
      'loadMilestones',
      'loadNotification',
      'incrementNotificationCounter',
      'logout',
      'setProduction',
      'setCurrentEpisode',
      'setSupportChat',
      'toggleDarkTheme',
      'toggleSidebar',
      'toggleUserMenu'
    ]),

    onLogoutClicked() {
      this.logout((err, success) => {
        this.$socket.disconnect()
        if (err) console.error(err)
        this.toggleUserMenu()
        if (success) this.$router.push('/login')
      })
    },

    getContextRoute(section) {
      const route = {
        name: section,
        params: {
          production_id: this.currentProduction.id
        }
      }
      if (this.currentEpisode && section !== 'episode-stats') {
        route.name = 'episode-' + route.name
        route.params.episode_id = this.currentEpisode.id
      }
      return route
    },

    getCurrentSectionFromRoute() {
      let name = ''
      const segments = this.$route.path.split('/')
      if (this.isTVShow) name = segments[5]
      if (this.isTVShow && name && name.length === 36) name = 'episodes'
      if (!name) {
        name = segments[3]
        if (name === 'episodes' && segments.length === 6) {
          name = segments[5]
        }
      }
      if (name === 'asset-types') name = 'assetTypes'
      if (name === 'news-feed') name = 'newsFeed'
      return name
    },

    updatePlaylistOptions() {
      this.playlistOptions = this.playlists.map(pl => {
        return { 'label': pl.name, 'value': pl.id }
      })
      const playlistId = this.$route.params.playlist_id
      if (playlistId) {
        this.playlistSelected = playlistId
      }
    },

    updateContext(productionId) {
      if (productionId) {
        this.setProductionFromRoute()
      }
    },

    clearContext() {
      this.silent = true
      this.currentProductionId = null
      this.currentProjectSection = null
      if (!this.isTVShow) {
        this.setCurrentEpisode(null)
        this.currentEpisodeId = null
      }
      this.setProduction(null)
      this.silent = false
    },

    setProductionFromRoute() {
      const routeProductionId = this.$route.params.production_id
      const routeEpisodeId = this.$route.params.episode_id

      if (this.isProductionChanged(routeProductionId)) {
        this.configureProduction(routeProductionId)
      } else if (this.isEpisodeChanged(routeEpisodeId)) {
        this.configureEpisode(routeEpisodeId)
      } else {
        this.updateCombosFromRoute()
      }
    },

    configureProduction(routeProductionId) {
      this.setProduction(routeProductionId)
      if (this.isTVShow) {
        this.loadEpisodes()
          .then(episodes => {
            this.updateCombosFromRoute()
          })
          .catch(console.error)
      } else {
        this.updateCombosFromRoute()
      }
    },

    configureEpisode(routeEpisodeId) {
      if (this.episodes.length < 2) {
        this.loadEpisodes()
          .then(episodes => {
            this.setEpisodeFromRoute()
            this.updateCombosFromRoute()
          })
          .catch(console.error)
      } else {
        this.setEpisodeFromRoute()
        this.updateCombosFromRoute()
      }
    },

    isProductionChanged(productionId) {
      return (
        !this.currentProduction ||
        this.currentProductionId !== productionId ||
        this.currentProduction.id !== productionId
      )
    },

    isEpisodeChanged(episodeId) {
      return (
        this.isTVShow &&
        (!this.currentEpisode ||
          this.currentEpisodeId !== episodeId ||
          this.currentEpisode.id !== episodeId)
      )
    },

    setEpisodeFromRoute() {
      const routeEpisodeId = this.$route.params.episode_id
      if (this.isEpisodeChanged(routeEpisodeId)) {
        if (routeEpisodeId && this.isTVShow) {
          this.setCurrentEpisode(routeEpisodeId)
        }
      } else if (!routeEpisodeId) {
        this.silent = true
        this.currentEpisodeId = null
        this.silent = false
      }
    },

    updateCombosFromRoute() {
      const section = this.getCurrentSectionFromRoute()
      this.silent = true
      this.currentProjectSection = section
      this.silent = false // wtf is this doing?
    }
  },

  watch: {
    $route() {
      const productionId = this.$route.params.production_id
      this.updateContext(productionId)
    },

    playlistSelected() {
      this.$router.push(getPlaylistPath(
        this.currentProduction.id,
        this.currentEpisode ? this.currentEpisode.id : null,
        this.playlistSelected
      ))
    },

    playlists() {
      this.updatePlaylistOptions()
    }
  },

  socket: {
    events: {
      'notification:new' (eventData) {
        if (this.user.id === eventData.person_id) {
          const notificationId = eventData.notification_id
          this.loadNotification(notificationId)
        }
      },

      'person:update'(eventData) {
        if (this.user.id === eventData.person_id) {
          this.$refs.avatar.reloadAvatar()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.nav {
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
  left: 0;
  max-height: 60px;
  min-height: 60px;
  position: fixed;
  right: 0;
  margin-left: 0;
}

#toggle-menu-button {
  font-size: 2em;
}

.avatar {
  margin-right: 10px;
  min-width: 40px;
}

.user-nav {
  cursor: pointer;
  min-width: 150px;
}

.user-menu {
  position: fixed;
  top: 60px;
  width: 200px;
  min-width: 150px;
  right: 0;
  background-color: white;
  padding: 1em 1em 1em 1em;
  z-index: 203;
  box-shadow: 2px 3px 3px rgba(0,0,0,0.2);
  transition-property: all;
  transition-duration: .5s;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  border-left: 1px solid $white-grey;
  border-bottom: 1px solid $white-grey;
}

.user-menu ul {
  margin-left: 0;
}

.user-menu li {
  cursor: pointer;
  padding: 0.2em;
  font-size: 1.1em;
  list-style-type: none;
}

.user-menu li a {
  color: $white;
}

#c-mask-user-menu {
  position: fixed;
  z-index: 202;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  overflow: hidden;
  background-color: #000;
  opacity: 0;
}

#c-mask-user-menu.is-active {
  width: 100%;
  height: 100%;
}

.nav-right {
  padding-right: 0;
  flex-grow: 0;
}

.context-selector-label {
  margin-right: 1em;
}

.episode-selector {
  background: $black;
  border: 1px solid $grey;
  border-radius: 10px;
}

.context-selector {
  margin-right: 1em;
  margin-bottom: 0.5em;
}

.icon-link {
  margin: 0 0.5em;
}

strong {
  margin-right: 1em;
  margin-left: 1em;
}

.version {
  color: $grey;
}

.user-name {
  color: $white;
  min-width: 130px;
  text-align: left;
}

.nav-left {
  padding-top: 8px;
}

@media screen and (max-width: 768px) {
  .home-button {
    display: none;
  }

  .nav-right {
    display: flex;
    flex: 0;
  }

  .nav-item {
    justify-content: right;
  }

  .user-name {
    display: none;
  }

  .avatar {
    margin-right: 0;
  }

  .user-menu {
    right: -160;
  }

  .icon-link,
  .context-selector-label {
    display: none;
  }

  .field.context-selector {
    padding: 0;
    margin-top: 2em;
  }
}

.block-cont {
  display: block;
}

.crumb-trail {
  width: fit-content;
  margin-left: 1em;
  margin-top: -0.7em;
  margin-bottom: 6px;
}

.crumb-pointer{
  padding-left: 0.8em;
  padding-right: 0.8em;
}

.production-links {
  margin-right: 3em;
  > * {
    width: max-content;
  }
}

.playlist-selector {
  width: 25
  0px;
  margin-top: 1em;
}

:deep(.combobox) {
  background: $black;
  color: $white;
  border: 1px solid $grey;
}

:deep(.selected-episode-line) {
  background: $dark-grey-strong;
  color: $white;
}

:deep(.episode-line) {
  background: $dark-grey-strong;
  color: $white;
}

:deep(.production-line) {
  background: $dark-grey-strong;
  color: $white;
}

:deep(.avatar-name) {
  color: $white;
}

:deep(.episode-menu>.select-input) {
  position: absolute;
  top: 50px;
}

:deep(.select-input) {
  background: $black;
}

// .dark {
  a,
  .user-menu a {
    color: $white-grey;
  }

  #toggle-menu-button:hover {
    color: $white-grey;
  }

  .topbar .nav,
  .user-menu {
    background-color: $black;
    color: $white-grey;
    border-left: 1px solid #2f3136;
    border-bottom: 1px solid #2f3136;
  }
// }
</style>
